<template>
    <rkm-form
        ref="Form"
        show-legend
        v-if="model"
    >

        <FormEndereco
            :data="{ form, model }"
            :id="id"
            @redirect="redirect"
            @exit="exit"
        />

        <FormRecusa
            :data="{ form, model }"
            :id="id"
        />

        <FormResidencia
            :data="{ form, model }"
            :id="id"
        />

        <FormInformacao
            :data="{ form, model }"
        />

        <FormCadastro
            :data="{ form, model }"
            :id="id"
        />

        <FormResidentes
            :data="{ form, model }"
            :id="id"
        />

        <FormInstituicao
            :data="{ form, model }"
            :id="id"
        />
    </rkm-form>
</template>

<script>
// Vuex.
import { mapActions } from "vuex";

// Mixins
import { repository, stringCase, data, object, formats, error, unmask } from "@/mixins";


// Components
import FormEndereco from './components/endereco/Form.vue'
import FormResidencia from './components/residencia/Form.vue'
import FormCadastro from './components/cadastro/Form.vue'
import FormRecusa from './components/recusa/Form.vue'
import FormInformacao from './components/informacao/Form.vue'
import FormResidentes from './components/residentes/Form.vue'
import FormInstituicao from './components/instituicao/Form.vue'

export default {
    components: {
        FormEndereco,
        FormResidencia,
        FormCadastro,
        FormRecusa,
        FormInformacao,
        FormResidentes,
        FormInstituicao,
    },
    computed: {

    },
    created() {

        this.repositories = {
            cadastroDomiciliar: this.getConectaSusRepository('atencaoBasica.cadastroDomiciliar'),
            logradouro: this.getConectaSusRepository('cadastro.localizacao.logradouro')
        },

        this.load();
    },
    data: () => ({
        model: null,
        form: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        async validate() {

            return this.$refs.Form.validate()
        },
        load() {

            this.setLoading()

            if(this.id) {
                this.repositories.cadastroDomiciliar.edit(this.id)
                    .then(({ data }) => {

                        this.model = Object.assign(data.model)
                        this.form = Object.assign(data.form)
                        this.model.residencia.moradores = data.form.residentes.length
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                this.repositories.cadastroDomiciliar.create()
                    .then(({ data }) => {

                        this.model = Object.assign(data.model)
                        this.form = Object.assign(data.form)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        save() {

            this.$refs['Form'].validate()
                .then(valid => {

                if (!valid) return

                    this.setLoading()

                    this.repositories.cadastroDomiciliar.store(this.prepareData())
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
            })
        },
        prepareData() {

            const id = this.id

            const endereco = this.clone(this.model.endereco)
            endereco.logradouro_id = endereco.logradouro.id
            endereco.loteamento_id = endereco.loteamento ? endereco.loteamento.id : null

            const cadastro = this.clone(this.model.cadastro)
            cadastro.usuario_id = cadastro.usuario.id
            cadastro.dataUsuarioResponsavel = this.getFormatedDate(cadastro.dataUsuarioResponsavel, 'YYYY-MM-DD')

            const residencia = this.clone(this.model.residencia)
            const informacao = this.clone(this.model.informacao)
            const instituicao = this.clone(this.model.instituicao)

            if (instituicao.cnsResponsavelTecnico) {

                instituicao.cnsResponsavelTecnico = this.unMaskCns(instituicao.cnsResponsavelTecnico)
            }

            if (instituicao.telefoneResponsavelTecnico) {

                instituicao.telefoneResponsavelTecnico = this.unMaskPhone(instituicao.telefoneResponsavelTecnico)
            }

            const recusaCadastro = this.clone(this.model.recusaCadastro)
            const origem = 'atencaoBasica'

            delete(cadastro.usuario)
            delete(endereco.logradouro)

            return this.camelObjectKeysToSnakeRecursive({
                id, cadastro, endereco, residencia, informacao, instituicao, recusaCadastro, origem
            })
        },
        redirect(data) {

            this.$emit('redirect', data)
        },
        exit() {

            this.$emit('save')
        },
    },
    mixins: [ repository, stringCase, data, object, formats, error, unmask ],
    props: {
        id: { type: Number }
    }
}
</script>